const TUSD = ({ ...props }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="10" cy="10" r="10" fill="white" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.61014 0.00784063C4.98584 0.20318 1.10497 3.49987 0.191645 8.00854C-0.0639676 9.27028 -0.0638645 10.729 0.191851 11.9914C0.503797 13.5313 1.18925 15.0029 2.16829 16.2347C2.51062 16.6654 3.3087 17.4696 3.71561 17.7939C6.07184 19.6716 9.09482 20.3968 12.0411 19.7911C15.8903 18.9998 18.967 15.938 19.7799 12.0898C20.3425 9.42614 19.8178 6.7017 18.3054 4.434C17.932 3.87402 17.6455 3.53048 17.0701 2.95277C16.3292 2.20883 15.7025 1.73113 14.8279 1.24371C13.2963 0.390137 11.3687 -0.0664337 9.61014 0.00784063ZM8.30946 5.42354C8.21797 6.61324 7.4866 7.68087 6.39482 8.21848C6.11192 8.35779 5.64599 8.49435 5.36017 8.52173C5.24015 8.53324 5.0917 8.55031 5.03028 8.55973L4.91858 8.57683V6.85753V5.13826H6.625H8.33139L8.30946 5.42354ZM15.075 6.85599V8.55653L13.3823 8.56543L11.6896 8.57436V12.0098V15.4452L9.99681 15.4363L8.30406 15.4274L8.29437 11.9061C8.28777 9.51925 8.29667 8.29217 8.32194 8.09738C8.51651 6.59812 9.70992 5.39864 11.2285 5.17612C11.3403 5.15974 12.2515 5.1484 13.2534 5.15091L15.075 5.15544V6.85599Z"
      fill="#1A5AFF"
    />
  </svg>
);
export default TUSD;
